export enum CalculatedVariablesActionType {
  ResetState = 'calculatedVariables/resetState',
}
